import React, { createContext, ReactNode } from "react";
import { configureApiClients, globalApiOptions } from "@rentablo/api";
import { ENUM_COMPATIBILITY_VERSION } from "@constants";

const ApiContext = createContext<undefined>(undefined);

export const ApiProvider = ({ children }: { children: ReactNode }) => {
  configureApiClients({
    apiBasePath: import.meta.env.VITE_APP_API_BASE_URL!,
    quotesBasePath: import.meta.env.VITE_APP_API_QUOTES_BASE_URL!,
    appPath: import.meta.env.VITE_APP_V2_URL!,
    apiV3BasePath:
      import.meta.env.VITE_APP_API_V3_BASE_URL ??
      import.meta.env.VITE_APP_API_BASE_URL!,
    apiParserBasePath: import.meta.env.VITE_APP_API_PARSER_URL!,
    enumCompatibilityVersion: ENUM_COMPATIBILITY_VERSION,
  });

  if (!globalApiOptions) return null;

  return (
    <ApiContext.Provider value={undefined}>{children}</ApiContext.Provider>
  );
};
